import React from 'react';

import Config from '../../shared/config/Configuration';
import Slider from '../slider/Slider';
import Scrollable from '../../shared/tools/Scrollable';
import Button from '../../elements/button/Button';

import styles from './Header.module.scss';


class Header extends React.Component {
  onClickNextButton = () => {
    Scrollable.scrollTo(Config.sections[0].id);
  };

  render() {
    return (
      <header>
        <div className={styles.Slider}>
          <Slider/>
        </div>
        <div className={styles.Description}>
          <h1>{Config.title}</h1>
          <h2>{Config.subtitle}</h2>
        </div>
        <Button bClass={styles.Button} elemStyle='next' onClick={this.onClickNextButton}>
          Przejdź dalej
        </Button>
      </header>
    );
  }
}

export default Header;
